import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isEnabled } = useFeatureFlags();

  const socialLinks = [
    { label: 'LinkedIn', icon: 'Linkedin', url: 'https://www.linkedin.com/in/prepxai/' },
    { label: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/prepxai' },
    { label: 'X', icon: 'Twitter', url: 'https://twitter.com/prepxai' },
    { label: 'Facebook', icon: 'Facebook', url: 'https://www.facebook.com/prepxai' },
    { label: 'YouTube', icon: 'Youtube', url: 'https://www.youtube.com/@prepxai' }

  ];

  const footerColumns = {
    company: {
      title: 'Company',
      links: [
        { label: 'About Us', path: '#' },
        { label: 'Careers', path: '#' },
        { label: 'Contact Us', path: '#' },
        { label: 'Corporate Solution', path: '#' }
      ]
    },
    // explore: {
    //   title: 'Explore',
    //   links: [
    //     { label: 'Practice Problems', path: '/practice' },
    //     { label: 'Blogs', path: '/blogs' },
    //     { label: 'Community', path: '/community' },
    //     { label: 'Leaderboard', path: '/leaderboard' },
    //     { label: 'Upskill Courses', path: '/learn' },
    //     ...(isEnabled('jobs') ? [{ label: 'Jobs', path: '/jobs' }] : [])
    //   ]
    // },
    tutorials: {
      title: 'Legal',
      links: [
        { label: 'Terms of Service', path: '/terms' },
        { label: 'Privacy Policy', path: '/privacy' },
        { label: 'Cookie Policy', path: '/cookies' },
        { label: 'Cookie Preferences', action: 'open-cookie-preferences' },
        { label: 'Refund Policy', path: '/refund' },
        { label: 'AI Processing Consent', path: '/interview-consent' },
        { label: 'Beta Disclaimer', path: '/beta-disclaimer' }
      ]
    },
    /*
    Pilot disabled: support/dispute links are hidden during restricted pilot.
    support: {
      title: 'Support',
      links: [
        { label: 'Help Center', path: '/support' },
        { label: 'Report Issue', path: '/support' },
        { label: 'Disputes', path: '/support' },
        { label: 'Feedback', path: '#' }
      ]
    },
    */
    // resources: {
    //   title: 'Resources',
    //   links: [
    //     /*
    //     Pilot disabled: reviews page hidden during restricted pilot.
    //     { label: 'Product Reviews', path: '/review' },
    //     */
    //     { label: 'Engineering Blog', path: '/blogs' },
    //     { label: 'Documentation', path: '/learn' },
    //     { label: 'Newsletter', path: '#' },
    //     { label: 'Case Studies', path: '#' }
    //   ]
    // },
    preparation: {
      title: 'Preparation',
      links: [
        { label: 'Mock Interviews', path: '/practice' },
        { label: 'Resume Builder', path: '/resume-analyzer' },
        { label: 'Skill Assessment', path: '/practice' },
        { label: 'Expert Guidance', path: '#' }
      ]
    }
  };

  return (
    <footer className="bg-white border-t border-emerald-200/50 dark:border-[#1d1e26] relative overflow-hidden mt-auto">
      {/* Premium Footer Background Transition */}
      <div className="absolute bottom-0 left-0 right-0 h-[350px] bg-gradient-to-t from-emerald-200/40 dark:from-[#10E58F]/10 to-transparent pointer-events-none z-0" />

      {/* Oversized background watermark — decorative only, adds no layout height */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 z-0 select-none overflow-hidden whitespace-nowrap text-center text-[29vw] leading-[0.7] tracking-[-0.085em] text-emerald-950/[0.045] dark:text-white/[0.09]"
        style={{ fontWeight: 900 }}
      >
        prepxai
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-9 mb-12">
          {/* Logo & description & Addresses */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-normal tracking-tight text-slate-900">
                prepx<span className="text-emerald-600">ai</span>
              </span>
            </div>
 
            <div className="space-y-4">
              <div className="flex gap-3">
                <div className="mt-1 w-5 h-5 rounded-full bg-emerald-50 dark:bg-slate-800/40 flex items-center justify-center flex-shrink-0">
                  <Icon name="MapPin" size={12} className="text-emerald-600" />
                </div>
                <div>
                  <h4 className="text-[10px] font-black tracking-widest text-slate-900 mb-1">Corporate Address:</h4>
                  <p className="text-[11px] text-slate-700 dark:text-slate-400 leading-relaxed font-medium">
                    .....
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <div className="mt-1 w-5 h-5 rounded-full bg-emerald-50 dark:bg-slate-800/40 flex items-center justify-center flex-shrink-0">
                  <Icon name="MapPin" size={12} className="text-emerald-600" />
                </div>
                <div>
                  <h4 className="text-[10px] font-black tracking-widest text-slate-900 mb-1">Registered Address:</h4>
                  <p className="text-[11px] text-slate-700 dark:text-slate-400 leading-relaxed font-medium">
                  .....
                  </p>
                  <p className="text-[11px] text-emerald-600 font-bold mt-2">
                    contact@prepxai.in
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Link columns - Centered Content */}
          <div className="lg:col-span-6 grid grid-cols-2 md:grid-cols-3 gap-y-10 gap-x-4">
            {Object.entries(footerColumns).map(([key, column]) => (
              <div key={key}>
                <h4 className="text-[10px] font-black tracking-widest text-emerald-600 mb-4 border-b border-emerald-50 dark:border-[#1d1e26] pb-2">
                  {column.title}
                </h4>
                <ul className="space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      {link.action ? (
                        <button
                          onClick={() => {
                            if (link.action === 'open-cookie-preferences') {
                              window.dispatchEvent(new CustomEvent('open-cookie-preferences'));
                            }
                          }}
                          className="text-[11px] font-medium text-slate-700 dark:text-slate-400 hover:text-emerald-600 transition-all block text-left"
                        >
                          {link.label}
                        </button>
                      ) : (
                        <Link
                          to={link.path}
                          className="text-[11px] font-medium text-slate-700 dark:text-slate-400 hover:text-emerald-600 transition-all block"
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Newsletter & Socials - Right Anchor */}
          <div className="lg:col-span-3">
            <div className="bg-emerald-50/40 dark:bg-[#111216]/55 rounded-2xl p-5 border border-emerald-200/80 dark:border-white/15">
              <h4 className="text-[10px] font-black tracking-widest text-slate-900 mb-3">Stay Updated</h4>
              <p className="text-[11px] text-slate-700 dark:text-slate-400 mb-4 font-medium leading-relaxed">
                Join our community for the latest interview strategies and platform updates.
              </p>
              
              <div className="space-y-3 mb-5">
                <input 
                  type="email" 
                  placeholder="Email address" 
                  className="bg-white dark:bg-[#08080a] border border-emerald-200 dark:border-white/15 rounded-xl px-4 py-2.5 text-[11px] font-medium text-slate-800 dark:text-slate-200 placeholder:text-slate-500 w-full focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 dark:focus:border-[#10E58F] transition-all shadow-sm"
                />
                <button className="bg-emerald-600 text-white dark:text-[#08080a] w-full py-2.5 rounded-xl text-[10px] font-black tracking-wider hover:bg-emerald-700 transition-all shadow-md shadow-emerald-200 dark:shadow-none flex items-center justify-center gap-2">
                  Subscribe
                  <Icon name="ArrowRight" size={14} />
                </button>
              </div>

              <div className="pt-4 border-t border-emerald-200/70 dark:border-white/10">
                <div className="flex items-center gap-3">
                  {socialLinks.map((social) => (
                    <a
                      key={social.label}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Follow prepxai on ${social.label}`}
                      title={social.label}
                      className="w-8 h-8 rounded-full bg-white dark:bg-[#111216] hover:bg-emerald-600 text-slate-600 dark:text-slate-400 hover:text-white dark:hover:text-[#08080a] flex items-center justify-center transition-all duration-300 shadow-sm border border-emerald-200/70 dark:border-white/15"
                    >
                      <Icon name={social.icon} size={14} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-5 flex flex-col items-center gap-3">
          <p className="text-[11px] font-medium text-slate-500 dark:text-slate-500 tracking-wide">
            Built by IITians with <span className="text-red-500">❤️</span> for all
          </p>
          <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] font-medium text-slate-700 dark:text-slate-400">
            © {currentYear} prepxai. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-8 text-[11px] font-medium text-slate-700 dark:text-slate-400">
            <Link to="/privacy" className="hover:text-emerald-600 transition-all">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-emerald-600 transition-all">Terms of Service</Link>
            <Link to="/cookies" className="hover:text-emerald-600 transition-all">Cookie Policy</Link>
            <button onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-preferences'))} className="flex items-center gap-2 hover:text-emerald-700 transition-all text-left text-emerald-600 dark:text-emerald-500 font-semibold">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="14" viewBox="0 0 30 14" className="shrink-0">
                <path d="M7.4 12.8h6.8l3.1-11.6H7.4C4.2 1.2 1.6 3.8 1.6 7c0 3.2 2.6 5.8 5.8 5.8z" fill="white"/>
                <path d="M22.6 0H7.4C3.5 0 0 3.1 0 7s3.5 7 7.4 7h15.2c3.9 0 7.4-3.1 7.4-7s-3.5-7-7.4-7zm-10.4 12.8H7.4C4.2 12.8 1.6 10.2 1.6 7s2.6-5.8 5.8-5.8h9.9l-3.1 11.6zm10.4-1.2h-6.8l3.1-11.6h3.7c3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8z" fill="currentColor"/>
                <path d="M22.6 1.2c3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8h-6.8l3.1-11.6h3.7z" fill="currentColor"/>
                <path d="M4.6 6.8l1.6 1.6 3.2-3.2" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21.2 4.8l-2.4 4.4M18.8 4.8l2.4 4.4" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Cookie Preferences
            </button>
            <Link to="/refund" className="hover:text-emerald-600 transition-all">Refund Policy</Link>
            <Link to="/interview-consent" className="hover:text-emerald-600 transition-all">AI Processing Consent</Link>
            <Link to="/beta-disclaimer" className="hover:text-emerald-600 transition-all">Beta Disclaimer</Link>
          </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
